<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showSupportChat") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Chat Data -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="">
        <div class="row">
          <!-- Start:: Employee Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.employeeName')"
            v-model.trim="chatData.employee_name"
            disabled
          />
          <!-- End:: Employee Name -->

          <!-- Start:: Job Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.jobName')"
            v-model.trim="chatData.job_name"
            disabled
          />
          <!-- End:: Job Name -->

          <!-- Start:: Phone Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="chatData.mobile"
            disabled
          />
          <!-- End:: Phone Number -->

          <!-- Start:: Last Message Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.lastMessageDate')"
            v-model.trim="chatData.last_message_date"
            disabled
          />
          <!-- End:: Last Message Date -->

          <!-- Start:: Chat Messages -->
          <div class="col-12 mt-4">
            <h5 class="mb-3">{{ $t("PLACEHOLDERS.chatMessages") }}</h5>
            <div class="chat_messages_container">
              <div
                v-for="message in chatData.messages"
                :key="message.id"
                :class="[
                  'message_bubble',
                  message.from_id === chatData.user_id
                    ? 'user_message'
                    : 'admin_message',
                ]"
              >
                <div class="message_content">
                  <p>{{ message.message_text }}</p>
                  <span class="message_time">{{
                    formatDate(message.created_at)
                  }}</span>
                </div>
              </div>

              <div v-if="chatData.messages.length === 0" class="no_messages">
                <p>{{ $t("MESSAGES.noMessagesYet") }}</p>
              </div>
            </div>
          </div>
          <!-- End:: Chat Messages -->

          <!-- Start:: Send Reply -->
          <div class="col-12 mt-4">
            <h5 class="mb-3">{{ $t("PLACEHOLDERS.sendReply") }}</h5>
            <base-input
              col="12"
              type="textarea"
              rows="4"
              :placeholder="$t('PLACEHOLDERS.typeYourReply')"
              v-model.trim="replyMessage"
            />
            <base-button
              styleType="primary_btn"
              class="mt-3"
              @fireClick="sendReply"
              :btnText="$t('BUTTONS.send')"
              :isLoading="isWaitingRequest"
              :disabled="!replyMessage || replyMessage.length < 3"
            />
          </div>
          <!-- End:: Send Reply -->
        </div>
      </form>
    </div>
    <!-- END:: Chat Data -->
  </div>
</template>

<script>
export default {
  name: "ShowSupportChat",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Chat Data
      chatData: {
        id: null,
        employee_name: null,
        job_name: null,
        mobile: null,
        last_message_date: null,
        user_id: null,
        messages: [],
      },
      // End:: Chat Data

      // Start:: Reply Data
      replyMessage: null,
      // End:: Reply Data
    };
  },

  methods: {
    // Start:: Format Date
    formatDate(dateString) {
      if (!dateString) return "";
      return new Date(dateString).toLocaleString(
        this.$i18n.locale === "ar" ? "ar-EG" : "en-US",
        {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      );
    },
    // End:: Format Date

    // Start:: Get Chat Data
    async getChatData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `chats`,
        });

        // Find the specific chat by ID from the route params
        const chatId = parseInt(this.$route.params.id);
        const chat = res.data.data.find((c) => c.id === chatId);

        if (chat) {
          this.chatData.id = chat.id;
          this.chatData.employee_name = chat.user?.name || "-";
          this.chatData.job_name = chat.user?.job?.name || "-";
          this.chatData.mobile = chat.user?.mobile || "-";
          this.chatData.last_message_date =
            chat.last_message?.created_at || "-";
          this.chatData.user_id = chat.user?.id;
          this.chatData.messages = chat.messages || [];
        } else {
          this.$message.error(this.$t("MESSAGES.chatNotFound"));
          this.$router.push({ path: "/support-chat/all" });
        }
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(this.$t("MESSAGES.errorLoadingData"));
      }
    },
    // End:: Get Chat Data

    // Start:: Send Reply
    async sendReply() {
      if (!this.replyMessage || this.replyMessage.length < 3) {
        this.$message.error(this.$t("MESSAGES.replyMessageRequired"));
        return;
      }

      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("message", this.replyMessage);
      REQUEST_DATA.append("to_id", this.chatData.user_id);
      REQUEST_DATA.append("to_type", "user");

      try {
        await this.$axios({
          method: "POST",
          url: `chats/${this.chatData.id}/send-message`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.replySentSuccessfully"));

        // Clear reply message
        this.replyMessage = null;

        // Reload chat data to show new message
        await this.getChatData();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Send Reply
  },

  async created() {
    await this.getChatData();
  },
};
</script>

<style scoped>
.chat_messages_container {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px;
  min-height: 400px;
  max-height: 600px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.message_bubble {
  display: flex;
  margin-bottom: 10px;
}

.user_message {
  justify-content: flex-end;
}

.user_message .message_content {
  background-color: #e3f2fd;
  border-radius: 15px 15px 0 15px;
  margin-left: auto;
}

.admin_message {
  justify-content: flex-start;
}

.admin_message .message_content {
  background-color: #fff;
  border-radius: 15px 15px 15px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.message_content {
  max-width: 70%;
  padding: 12px 16px;
  word-wrap: break-word;
}

.message_content p {
  margin: 0 0 5px 0;
  font-size: 14px;
  line-height: 1.5;
}

.message_time {
  font-size: 11px;
  color: #666;
  display: block;
  margin-top: 5px;
}

.no_messages {
  text-align: center;
  color: #999;
  padding: 50px;
}

.no_messages p {
  font-size: 16px;
}

/* RTL Support */
[dir="rtl"] .user_message .message_content {
  border-radius: 15px 15px 15px 0;
  margin-left: 0;
  margin-right: auto;
}

[dir="rtl"] .admin_message .message_content {
  border-radius: 15px 15px 0 15px;
}
</style>
